import { watchDepartmentSaga } from "component/AddPage/slice/saga";
import { watchCheckPageSaga } from "component/Header/slice/saga";
import { all } from "redux-saga/effects";

export default function* rootSaga() {
  yield all([watchCheckPageSaga(), watchDepartmentSaga()]);
}
